import {
    useMutation,
} from '@tanstack/react-query'

import {
    useEffect,
} from 'react'

import {
    useLocation,
} from 'react-router-dom'
import FullScreenDialog from '../../Components/FullScreenDialog'
import Overlay from '../../Components/Overlay'

import acceptCompanyInvitationMutation from './services/accept-company-invitation'

const AcceptCompanyInvitation = (ref) => {

    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    const {
        error: mutationError,
        isPending: mutationIsPending,
        mutate,
        data: mutationData,
    } = useMutation({
        mutationFn: acceptCompanyInvitationMutation,
    })

    useEffect(() => {
        mutate({
            key,
        })
    }, [],
    )

    const handleComplete = () => {
    }

    return (
        <div className="flex flex-col items-center justify-center py-4 bg-gray-100">

            Accept Company Invitation

            {
                mutationError && (
                    <p className="mt-1 text-base text-red-600 py-4 mx-auto">
                        Error
                    </p>
                )
            }

            {/* Overlay */}
            {
                mutationIsPending &&
                <Overlay />
            }

            {
                mutationData &&
                <FullScreenDialog
                    text={`You have joined VerifiedID`}
                    onSubmit={handleComplete}
                />
            }

        </div>
    )
}

export default AcceptCompanyInvitation
